import {
  ConnectionType,
  isMarketConfigured,
  MarketAccountTypeEnum,
  useMarketAccountsContext,
  useMarketsContext,
} from '@talos/kyoko';
import { useMemo } from 'react';
import type { MarketSelectorItem } from '../../../components/MarketSelector/types';
import { buildMarketSelectorItem } from '../../../components/MarketSelector/utils/items';

/**
 * Super simple hook that just grabs all market data configured markets, tries to flatten to (trading) accounts, and
 * returns as market selector items. No availability is put onto the items, they're just always selectable for now.
 */
export const usePriceGridMarketSelectorItems = () => {
  const { marketsList } = useMarketsContext();
  const { marketAccountsByMarket } = useMarketAccountsContext();

  // Grab all market accounts and markets uniquely that are trading markets
  return useMemo(() => {
    const items: MarketSelectorItem[] = [];
    for (const market of marketsList) {
      if (!isMarketConfigured(market, ConnectionType.MarketData)) {
        continue;
      }

      const marketAccounts = marketAccountsByMarket.get(market.Name);
      if (marketAccounts) {
        marketAccounts.forEach(marketAccount => {
          if (marketAccount.Type === MarketAccountTypeEnum.Trading) {
            items.push(buildMarketSelectorItem({ market, marketAccount, conditions: [] }));
          }
        });
      } else {
        // No market accounts within the market, but we still want to let the user select it for showing market data
        items.push(buildMarketSelectorItem({ market, conditions: [] }));
      }
    }

    return items;
  }, [marketsList, marketAccountsByMarket]);
};
